<template>
  <a-modal
    :title="null"
    :visible="flag"
    ok-text="下一步"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-tabs :default-active-key="active">
      <a-tab-pane key="1" tab="选择企业">
        <div class="tit">您的账户加入了以下企业，请选择你需要访问的企业：</div>
        <ul class="list">
          <li v-for="(item,index) in list" :key="index" :class="indexs==index?'c-active':''" class="item" @click="select(index,item)">{{ item.title }}</li>
        </ul>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
export default {
  components: {

  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flag: this.show,
      active: '1',
      list: [
        {
          title: '快金数据'
        },
        {
          title: '字节跳动'
        },
        {
          title: '阿里巴巴'
        }
      ],
      indexs: null
    }
  },
  watch: {
    show(val) {
      this.flag = val
    },
    flag(val) {
      this.$emit('update:show', val)
    }
  },
  methods: {
    close() {

    },
    handleCancel() {
      this.flag = false
    },
    handleOk() {},
    select(index, item) {
      this.indexs = index
    }
  }
}
</script>
<style scoped lang="scss">
    .tit{
        text-align:center;
        color:#525252;
        margin-top:10px;
        margin-bottom:10px;
    }
    .list{
        margin:15px 0;
        padding:0 50px;
        .item{
            position: relative;
            border:1px solid #e8e8e8;
            text-align:center;
            margin:10px 0;
            height:36px;
            line-height:36px;
            cursor: pointer;
        }
    }
</style>
